import {
    MERCHANT_SETTING_LOADING,
    MERCHANT_SETTING_SUCCESS,
    MERCHANT_SETTING_FAILURE,
  } from "../actions/MerchantSettingAction";
  
  const initialState = {
    data: {},
    loading: false,
    error: null,
  };
  
  const MerchantSettingReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_SETTING_LOADING:
        return { ...state, loading: true, error: null };
  
      case MERCHANT_SETTING_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case MERCHANT_SETTING_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default MerchantSettingReducer;